import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { ONBOARDING_FREE_SERVICE } from 'getting-started-shared-tasks/onboardingKeys';
import { GROUP_KEYS, FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { EXPERIENCE_NONE_PARAM, EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT, CUSTOMER_SERVICE_HUB_INTEREST } from '../constants/surveyConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { getServiceOnboardingKey } from '../utils/onboardingKeyUtils';
import { CRM_SIGNUP, SERVICE_SIGNUP } from '../constants/signupConstants';
const servicesExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: getServiceOnboardingKey(),
      groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_SERVICE
    };
  },
  checks: [{
    signupType: SERVICE_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: getServiceOnboardingKey(),
      groupKey: GROUP_KEYS.services
    };
  },
  checks: [{
    signupType: SERVICE_SIGNUP,
    survey: {
      crmExperience: [EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_HAS_USED_HUBSPOT]
    }
  }]
}, // As Hub Interest is auto-filled for non-CRM Signup Types, this check goes
// last as it will prematurely match more specific checks above.
{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: ONBOARDING_FREE_SERVICE,
      groupKey: FREE_GROUP_KEYS.freeServiceView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: CUSTOMER_SERVICE_HUB_INTEREST
    }
  }]
}];
export default servicesExperiencesChecks;